// Handler pro výběr fakturační adresy je přesunut níže do hlavního ready bloku
import $ from 'jquery';
import prestashop from 'prestashop';

prestashop.cart = prestashop.cart || {};

prestashop.cart.active_inputs = null;

let hasError = false;
let isUpdateOperation = false;
let errorMsg = '';


$(document).ready(() => {

  const promises = [];
  const $body = $('body');

  const abortPreviousRequests = () => {
    let promise;
    while (promises.length > 0) {
      promise = promises.pop();
      promise.abort();
    }
  };

  updateCompanyShoppingDiplay();
  updateDeliveryAddressDiplay();
  updateMessageDiplay();

  const handleUpdateDeliveryCountryAction = (event) => {
    event.preventDefault();

    updateRelatedDiplay('delivery');
  };
  $body.on('change', '#id_country_delivery', handleUpdateDeliveryCountryAction);

  const handleUpdateInvoiceCountryAction = (event) => {
    event.preventDefault();

    updateRelatedDiplay();
  };
  $body.on('change', '#id_country', handleUpdateInvoiceCountryAction);

  $body.on('change', '#address_delivery_select', (event) => {
    event.preventDefault();
    let id_address = $(this).val();
    addUpdateAddress(id_address, 'delivery');
  });

  $body.on('change', '#address_invoice_select', (event) => {
    event.preventDefault();
    let id_address = $(this).val();
    addUpdateAddress(id_address,'invoice');
  });

  const handleUpdateCompanyShoppingDiplayAction = (event) => {
    event.preventDefault();

    updateCompanyShoppingDiplay();
  };
  $body.on('change', '#company_shopping', handleUpdateCompanyShoppingDiplayAction);

  const handleUpdateMessageDiplayAction = (event) => {
    event.preventDefault();

    updateMessageDiplay();
  };
  $body.on('change', '#toggle_message', handleUpdateMessageDiplayAction);

  const handleUpdatePasswordDiplayAction = (event) => {
    event.preventDefault();

    updatePasswordDiplay();
  };
  $body.on('change', '#create_registration', handleUpdatePasswordDiplayAction);

  const handleUpdateDeliveryAddressDiplayAction = (event) => {
    event.preventDefault();

    updateDeliveryAddressDiplay();
  };
  $body.on('change', '#delivery_on_different_address', handleUpdateDeliveryAddressDiplayAction);

  const handleOrderConfirmationAction = (event) => {
    event.preventDefault();
    processGoogleApiValidation(() => {
      orderConfirmation();
    });
  };
  $body.on('click', '#order_confirmation_button', handleOrderConfirmationAction);

  const handleUpdateMessageAction = (event) => {
    event.preventDefault();

    updateMessage();
  };
  $body.on('blur', '#message', handleUpdateMessageAction);

  const handleTermsLinkClick = (event) => {
    event.preventDefault();
    let url = $(event.target).attr('href');

    if (url) {
      // TODO: Handle request if no pretty URL
      url += '?content_only=1';
      $.get(url, (content) => {
        $(prestashop.tsoSelectors.modal).find(prestashop.tsoSelectors.modalContent).html($(content).find('.page-cms').contents());
      }).fail((resp) => {
        prestashop.emit('handleError', { eventType: 'clickTerms', resp });
      });
    }

    $(prestashop.tsoSelectors.modal).modal('show');
  };
  $(prestashop.tsoSelectors.address.termsLink).on('click', handleTermsLinkClick);

  // Initialize Google Autocomplete
  initGoogleApiValidation();
  // Perform validation of address fields that already have some value
  processGoogleApiValidation();
});



const orderConfirmation = () => {
  const validation_errors = {};

  const term_select = $('input[name="cgv"]').is(':checked');
  if (conditions == 1 && !term_select) {
    validation_errors['conditions_errors'] = txtErrorConditions;
  }

  const has_validation_errors = !$.isEmptyObject(validation_errors);

  $('#addressess-errors').hide();
  $('#addressess-errors').html('');

  const data = $('#main-tso-form').find('input, select, textarea').serialize();

  $.ajax({
    type: 'POST',
    headers: { "cache-control": "no-cache" },
    url: checkoutUrl + '?rand=' + new Date().getTime(),
    async: true,
    cache: false,
    dataType: "json",
    data: 'ajax=true&method=orderConfirmation&' + data,
    success: (jsonData) => {
      if (!jsonData) {
        alert("TECHNICAL ERROR: unable to process registration - check log file for details");
        return;
      }

      if (has_validation_errors) {
        $.extend(jsonData.errors, validation_errors);
      }
      if (jsonData.hasError || has_validation_errors) {
        CheckUpdateAddressOperations.checkUpdateOpertation(jsonData);
        CheckUpdateAddressOperations.switchErrorStat();
        $('html, body').animate({ scrollTop: ($("#notifications").first().offset().top) }, 1200);
      } else {
        if (!has_validation_errors) {
          window.location = jsonData['payment_link'];
        } else {
          loadAddresses();
        }
      }
    },
    error: () => {
      alert("TECHNICAL ERROR: unable to process registration - check log file for details");
    }
  });
};

const addUpdateAddress = (id_address = 0, type) => {
  if (id_address != 0) {
    updateSelectedAddress(id_address, type);
  } else {
    addAddress(type);
  }
};

const updateSelectedAddress = (id_address, type) => {
  const delivery_on_different_address = $('#delivery_on_different_address').prop('checked');

  $.ajax({
    type: 'POST',
    headers: { "cache-control": "no-cache" },
    url: checkoutUrl + '?rand=' + new Date().getTime(),
    async: true,
    cache: false,
    dataType: "json",
    data: 'ajax=true&method=updateSelectedAddress&id_address=' + id_address + '&type=' + type + '&delivery_on_different_address=' + (delivery_on_different_address ? 1 : 0),
    success: (jsonData) => {
      if (!jsonData) {
        alert("TECHNICAL ERROR: unable to save adresses - check log file for details");
        return;
      }

      if (jsonData.hasError) {
        printErrors(jsonData.errors);
      } else {
        loadAddresses();
      }
    },
    error: () => {
      alert("TECHNICAL ERROR: unable to save adresses - check log file for details");
    }
  });
};

const addAddress = (type) => {
  const delivery_on_different_address = $('#delivery_on_different_address').prop('checked');

  $.ajax({
    type: 'POST',
    headers: { "cache-control": "no-cache" },
    url: checkoutUrl + '?rand=' + new Date().getTime(),
    async: true,
    cache: false,
    dataType: "json",
    data: 'ajax=true&method=addAddress&type=' + type + '&delivery_on_different_address=' + (delivery_on_different_address ? 1 : 0),
    success: (jsonData) => {
      if (jsonData.hasError) {
        printErrors(jsonData.errors);
      } else {
        loadAddresses();
      }
    },
    error: (XMLHttpRequest, textStatus) => {
      alert("TECHNICAL ERROR: unable to add new adrress \n\nDetails:\nError thrown: " + XMLHttpRequest + "\n" + 'Text status: ' + textStatus);
    }
  });
};

const loadAddresses = () => {
  $(prestashop.tsoSelectors.deliveryPayments.addressLoader).removeClass("off").addClass("on");
  $('#addressess-content').find('.addressess-data').html('');

  $.ajax({
    type: 'POST',
    headers: { "cache-control": "no-cache" },
    url: checkoutUrl + '?rand=' + new Date().getTime(),
    async: true,
    cache: false,
    dataType: "json",
    data: 'ajax=true&method=loadAddresses',
    success: (jsonData) => {
      if (jsonData.hasError) {
        printErrors(jsonData.errors);
      } else {
        $('#addressess-content').find('.addressess-data').append(jsonData.addressess_content);
        $(prestashop.tsoSelectors.deliveryPayments.addressLoader).removeClass("on").addClass("off");

        updateDeliveryAddressDiplay();
        updateRelatedDiplay('delivery');
        updateRelatedDiplay();
        // Re-initialize Google Autocomplete
        initGoogleApiValidation();
        // Perform validation of address fields that already have some value
        processGoogleApiValidation();
      }
    },
    error: (XMLHttpRequest, textStatus) => {
      alert("TECHNICAL ERROR: unable to load addresses \n\nDetails:\nError thrown: " + XMLHttpRequest + "\n" + 'Text status: ' + textStatus);
    }
  });
};

const updateRelatedDiplay = (address_type) => {
  updateStateDisplay(address_type);
  updateCompanyShoppingDiplay(address_type);
  updateZipDisplay(address_type);
  updatePhoneDisplay(address_type);
  updatePhoneCodesDisplay(address_type);
};

const updateStateDisplay = (address_type) => {
  const address_suffix = (address_type !== undefined ? '_' + address_type : '');
  $('select#id_state' + address_suffix + ' option:not(:first-child)').remove();

  const id_country = $('#id_country' + address_suffix).val();
  if (typeof (countries[id_country]) !== 'undefined') {
    const states = countries[id_country]['states'];
    const element = $('select#id_state' + address_suffix);
    const element_block = element.parent();

    if (typeof (states) !== 'undefined') {
      $(states).each((key, item) => {
        const selected = ((address_type !== undefined ? selected_state_invoice : selected_state_delivery) == item.id_state) ? 'selected="selected"' : '';
        const option = '<option value="' + item.id_state + '"' + (selected ? selected : "") + '>' + item.name + '</option>';
        element.append(option);
      });

      element_block.show();
    } else {
      element_block.hide();
    }
  }
};

const updateCompanyShoppingDiplay = (address_type) => {
  const address_suffix = (address_type !== undefined ? '_' + address_type : '');
  const company_shopping = $('#company_shopping' + address_suffix).prop('checked');

  if (company_shopping) {
    $('#company_shopping_fields' + address_suffix).show();
  } else {
    $('#company_shopping_fields' + address_suffix).hide();
  }
};

const updateZipDisplay = (address_type) => {
  const address_suffix = (address_type !== undefined ? '_' + address_type : '');
  const id_country = parseInt($('#id_country' + address_suffix).val());
  const element = $('#postcode' + address_suffix);

  if (typeof (countries[id_country]) !== 'undefined') {
    if (countries[id_country]['need_zip_code'] == 1) {
      element.closest(".form-group").show();
    } else {
      element.closest(".form-group").hide();
    }

    if (countries[id_country]['zip_code_format'] != '') {
      element.closest(".form-group").find('.zip-code-format').html(countries[id_country]['zip_code_format']);
      element.attr("required", "true");
    } else {
      element.closest(".form-group").find('.zip-code-format').html();
      element.attr("required", "false");
    }
  } else {
    element.attr("required", "false");
    element.closest(".form-group").hide();
  }
};

const updatePhoneDisplay = (address_type) => {
  const address_suffix = (address_type !== undefined ? '_' + address_type : '');
  const phone = $('#phone' + address_suffix);
  const phone_mobile = $('#phone_mobile' + address_suffix);

  if (onePhoneAtLeast) {
    if (phone.length == 1) {
      phone.attr("required", "true");
    } else if (phone_mobile.length == 1) {
      phone_mobile.attr("required", "true");
    }
  }
};

const updatePhoneCodesDisplay = (address_type) => {
  updatePhoneCodeDisplay('code_phone', address_type);
  updatePhoneCodeDisplay('code_phone_mobile', address_type);
};

const updatePhoneCodeDisplay = (type, address_type) => {
  const address_suffix = (address_type !== undefined ? '_' + address_type : '');
  const id_country = parseInt($('#id_country' + address_suffix).val());
  const element_selector = '#' + type + address_suffix;
  const element = $(element_selector);

  if (typeof (countries[id_country]) !== 'undefined') {
    const call_prefix = countries[id_country].call_prefix;
    if (call_prefix != '') {
      const call_prefix_val = '+' + call_prefix;

      if (element.length) {
        if ($(element_selector + " option[value='" + call_prefix_val + "']").length > 0) {
          element.val(call_prefix_val).change();
        }
      }
    }
  }
};

const updatePasswordDiplay = () => {
  const checked = $('#create_registration').prop('checked');
  if (checked) {
    $('#password-input').show();
  } else {
    $('#password-input').hide();
  }
};

const updateMessageDiplay = () => {
  const checked = $('#toggle_message').prop('checked');
  if (checked) {
    $('#message').parent().show();
  } else {
    $('#message').parent().hide();
  }
};

const updateDeliveryAddressDiplay = () => {
  const checked = $('#delivery_on_different_address').prop('checked');
  const id_address_invoice = $('#address_invoice_select').val();
  const id_address_delivery = $('#address_delivery_select').val();

  if (checked) {
    $('#id_country').prop('disabled', false);
    $('#id_country_desc').hide();

    $('#id_country_delivery').prop('disabled', true);
    $('#id_country_delivery_desc').show();

    $('#delivery-address-block').show();

    // if after checked delivery on different address stay same addresses
    // add new invoice address
    if (id_address_invoice > 0 && id_address_invoice == id_address_delivery) {
      // get first available id_address option
      let id_address = 0;
      let value = 0;
      $("#address_invoice_select option").each(function () {
        value = $(this).val();
        if (value != 0 && value != id_address_invoice && id_address === 0) {
          id_address = value;
        }
      });
      addUpdateAddress(id_address, 'delivery');
    }
  } else {
    $('#id_country').prop('disabled', true);
    $('#id_country_desc').show();

    $('#id_country_delivery').prop('disabled', false);
    $('#id_country_delivery_desc').hide();

    $('#delivery-address-block').hide();

    // if after unchecked delivery on different address stay different addresses
    // set invoice address by delivery
    if (id_address_invoice != id_address_delivery) {
      addUpdateAddress(id_address_invoice, 'delivery');
    }
  }
};

const updateMessage = () => {
  const message = encodeURIComponent($('#message').val());

  $.ajax({
    type: 'POST',
    headers: { "cache-control": "no-cache" },
    url: checkoutUrl + '?rand=' + new Date().getTime(),
    async: true,
    cache: false,
    dataType: "json",
    data: 'ajax=true&method=updateMessage&message=' + message,
    success: (jsonData) => {
      if (jsonData.hasError) {
        printErrors(jsonData.errors);
      }
    },
    error: (XMLHttpRequest, textStatus) => {
      alert("TECHNICAL ERROR: unable to update message \n\nDetails:\nError thrown: " + XMLHttpRequest + "\n" + 'Text status: ' + textStatus);
    }
  });
};

const initGoogleApiValidation = () => {

  if (typeof useGoogleApiValidation === 'undefined' || !useGoogleApiValidation || typeof google === 'undefined' || !google.maps || !google.maps.places) {
    return;
  }

  // Inicializace Google Autocomplete
  addGoogleAutocomplete();
  addGoogleAutocomplete('delivery');
};

const processGoogleApiValidation = (callback = () => {}) => {

  if (
    typeof useGoogleApiValidation === 'undefined' ||
    !useGoogleApiValidation ||
    typeof google === 'undefined' ||
    !google.maps ||
    !google.maps.places
  ) {
    callback();
    return;
  }

  ['', 'delivery'].forEach((type) => {
    if (
      typeof useGoogleApiValidation === 'undefined' ||
      !useGoogleApiValidation ||
      typeof google === 'undefined' ||
      !google.maps ||
      !google.maps.places
    ) {
      return;
    }

    const delivery_on_different_address = $('#delivery_on_different_address').prop('checked');

    if (
      (!delivery_on_different_address && type === 'delivery') ||
      (delivery_on_different_address && type !== 'delivery')
    ) {
      return;
    }

    let streetInputSelector = '#address1';
    if (type !== '') streetInputSelector += '_' + type;

    let zipInputSelector = '#postcode';
    if (type !== '') zipInputSelector += '_' + type;

    let cityInputSelector = '#city';
    if (type !== '') cityInputSelector += '_' + type;

    const street_value = $(streetInputSelector).val() || '';
    const zip_value = $(zipInputSelector).val() || '';
    const city_value = $(cityInputSelector).val() || '';

    if (street_value === '' || zip_value === '' || city_value === '') {
      callback();
      return;
    }

    const addressString = street_value + ', ' + zip_value + ', ' + city_value;
    getPlaceByAddressString(addressString, (autocompletePlace) => {
      if (autocompletePlace && autocompletePlace.place_id !== '') {
        validateAndFillAddressAsync(addressString, autocompletePlace, type, (res) => {
          if (res.result === true && res.placeId) {
            updatePlaceAjax(res.placeId, type, (ajaxDone) => {
              if (ajaxDone) {
                callback();
              }
            });
          }
        });
      }
      else {
        callback();
      }
    });
  });
};

const validateAddressWithGoogle = (address, callback = () => {}) => {
  const geocoder = new google.maps.Geocoder();
  geocoder.geocode({ address }, (results, status) => {
    if (status === 'OK' && results.length > 0) {
      const placeId = results[0].place_id;
      if (placeId && typeof google.maps.places !== 'undefined') {
        const service = new google.maps.places.PlacesService(document.createElement('div'));
        service.getDetails({ placeId }, (place, detailsStatus) => {
          if (detailsStatus === google.maps.places.PlacesServiceStatus.OK) {
            callback(true, place);
          } else {
            callback(true, results[0]);
          }
        });
      } else {
        callback(true, results[0]);
      }
    } else {
      callback(false, null);
    }
  });
};

// Sanitize postal codes before comparison (remove all non-alphanumeric chars)
const sanitizePostalCode = (code) => {
  return (code || '').toString().replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
};

/**
 * Async wrapper for address validation and filling using Google Places API.
 * Validates the address using both autocomplete and geocoder results, compares key fields,
 * and fills the address form inputs if validation passes. Supports callback for further actions.
 *
 * @param {string} addressString - The address string entered by the user.
 * @param {object} autocompletePlace - The place object returned by Google Autocomplete.
 * @param {string} type - The type of address (e.g., 'delivery' or 'invoice').
 * @param {function} callback - Callback function to execute after validation and filling.
 */
const validateAndFillAddressAsync = (addressString, autocompletePlace, type, callback = () => {}) => {
  // default values
  let fillAddress = null;
  let placeId = null;

  // Parse address from the autocomplete place
  const parsedAddress = parseAdrAddress(autocompletePlace);
  const autocompleteAddressComponents = parseAddressComponents(autocompletePlace.address_components);

  if (parsedAddress.postalCode === '') {
    console.log('No postal code found in autocomplete data, skipping address fill.');
    callback(false);
    return;
  }

  // Debugging logs
  if (useTsoLog) {
    console.log('autocompletePlace:', autocompletePlace);
    console.log('parsedAddress:', parsedAddress);
    console.log('autocompleteAddressComponents:', autocompleteAddressComponents);
    console.log('formatted_address:', autocompletePlace.formatted_address);
    console.log('place_id:', autocompletePlace.place_id);
    console.log('geometry_location:', autocompletePlace.geometry ? autocompletePlace.geometry.location.toString() : 'N/A');
    if (autocompletePlace.geometry) {
      console.log('Latitude:', autocompletePlace.geometry.location.lat());
      console.log('Longitude:', autocompletePlace.geometry.location.lng());
      console.log('Google Maps URL:', getGoogleMapsUrl(autocompletePlace.geometry.location.lat(), autocompletePlace.geometry.location.lng()));
    }
  }

  // If postal codes match, use the parsed address directly
  if (sanitizePostalCode(autocompleteAddressComponents.postalCode) === sanitizePostalCode(parsedAddress.postalCode)) {
    fillAddress = parsedAddress;
    placeId = autocompletePlace.place_id;
  }

  // second step validation with geocoder
  validateAddressWithGoogle(addressString, (isValid, geocoderPlace) => {
    if (isValid && geocoderPlace) {

      const geocoderParsedAddress = parseAdrAddress(geocoderPlace);
      const geocoderAddressComponents = parseAddressComponents(geocoderPlace.address_components);

      // Debugging logs
      if (useTsoLog) {
        console.log('geocoder parsedAddress:', geocoderParsedAddress);
        console.log('fill address:', fillAddress);
        console.log('place_id:', placeId);
        console.log('Address string for validation:', addressString);
        console.log('geocoderAddressComponents:', geocoderAddressComponents);
        console.log('formatted_address:', geocoderPlace.formatted_address);
        console.log('place_id:', geocoderPlace.place_id);
        console.log('geometry_location:', geocoderPlace.geometry ? geocoderPlace.geometry.location.toString() : 'N/A');
        if (geocoderPlace.geometry) {
          console.log('Latitude:', geocoderPlace.geometry.location.lat());
          console.log('Longitude:', geocoderPlace.geometry.location.lng());
          console.log('Google Maps URL:', getGoogleMapsUrl(geocoderPlace.geometry.location.lat(), geocoderPlace.geometry.location.lng()));
        }
        console.log('fill address before:', fillAddress);
      }

      // update address add street number if missing
      updateFillAddressWithNumbers(fillAddress, geocoderAddressComponents);
      console.log('fill address after:', fillAddress);

      // If cities and streets match, use the geocoded address
      if (
        autocompletePlace.place_id !== geocoderPlace.place_id &&
        (
          (
            (
              geocoderParsedAddress.city && parsedAddress.city &&
              geocoderParsedAddress.city.toLowerCase().indexOf(parsedAddress.city.toLowerCase()) !== -1
            ) &&
            (
              geocoderParsedAddress.street && parsedAddress.street &&
              geocoderParsedAddress.street.toLowerCase().indexOf(parsedAddress.street.toLowerCase()) !== -1
            )
          ) ||
          (
            geocoderParsedAddress.postalCode && parsedAddress.postalCode &&
            sanitizePostalCode(geocoderAddressComponents.postalCode) === sanitizePostalCode(parsedAddress.postalCode)
          )
        )
      ) {
        fillAddress = geocoderParsedAddress;
        placeId = geocoderPlace.place_id;
      }

      // Debugging logs
      if (useTsoLog) {
        console.log('compare city:', geocoderParsedAddress.city + ' x ' + parsedAddress.city);
        console.log('compare street:', geocoderParsedAddress.street + ' x ' + parsedAddress.street);
        console.log('compare postalCode:', sanitizePostalCode(geocoderAddressComponents.postalCode) + ' x ' + sanitizePostalCode(parsedAddress.postalCode));
        console.log('fill address after:', fillAddress);
        console.log('FINAL place_id:', placeId);
      }

      // fill address inputs
      fillAddressInputs(fillAddress, type);
      callback({ result: true, placeId: placeId });
    }
    else {
      callback({ result: false, placeId: null });
    }
  });
};

const updatePlaceAjax = (placeId, type, callback = () => {}) => {

  if (!placeId) {
    return;
  }

  const delivery_on_different_address = $('#delivery_on_different_address').prop('checked');

  // Save place_id and address via AJAX
  $.ajax({
    type: 'POST',
    headers: { "cache-control": "no-cache" },
    url: checkoutUrl + '?rand=' + new Date().getTime(),
    async: true,
    cache: false,
    dataType: "json",
    data: 'ajax=true&method=updateGoogleAddressPlaceId&place_id=' + placeId + '&type=' + type + '&delivery_on_different_address=' + (delivery_on_different_address ? 1 : 0),
    success: (jsonData) => {
      if (jsonData.hasError) {
        printErrors(jsonData.errors);
      }
      callback(true);
    },
    error: (XMLHttpRequest, textStatus, errorThrown) => {
      // silently fail
      // alert("TECHNICAL ERROR: unable to update google place id \n\nDetails:\nError thrown: " + XMLHttpRequest + "\n" + 'Text status: ' + textStatus);
      callback(false);
    }
  });
};

const getGoogleMapsUrl = (lat, lng) => {
  return 'https://www.google.com/maps/place/' + lat + ',' + lng;
};

const parseAdrAddress = (place) => {
  // Create a temporary element for easy HTML parsing
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = place.adr_address;

  const street = tempDiv.querySelector('.street-address')?.textContent || '';
  const postalCode = tempDiv.querySelector('.postal-code')?.textContent || '';
  const city = tempDiv.querySelector('.locality')?.textContent || '';
  const country = tempDiv.querySelector('.country-name')?.textContent || '';

  const address_components = place.address_components || [];
  let countryCode = '';

  if (address_components) {
    address_components.forEach((component) => {
      if (component.types.indexOf('country') !== -1) {
        countryCode = component.short_name;
      }
    });
  }

  return {
    street,
    postalCode,
    city,
    country,
    countryCode
  };
};

// Updates fillAddress.street and countryCode based on streetNumber, premise, and countryCode if they are not empty
const updateFillAddressWithNumbers = (fillAddress, geocoderAddressComponents) => {
  if (fillAddress && geocoderAddressComponents) {
    const city = fillAddress.city || '';
    let street = fillAddress.street || '';
    const streetNumber = geocoderAddressComponents.streetNumber || '';
    const premise = geocoderAddressComponents.premise || '';
    const countryCode = geocoderAddressComponents.countryCode || '';

    // Přidávej pouze pokud streetNumber/premise ještě nejsou ve street
    const hasStreetNumber = streetNumber && street.includes(streetNumber);
    const hasPremise = premise && street.includes(premise);

    // Pokud není ulice, ale je město, nastav ulici na město (některé adresy nemusí mít ulici)
    if (street === '' && city !== '') {
      street = city ;
    }

    if (!hasStreetNumber && !hasPremise && streetNumber && premise) {
      fillAddress.street = street + ' ' + premise + '/' + streetNumber;
    } else if (!hasPremise && premise) {
      fillAddress.street = street + ' ' + premise;
    } else if (!hasStreetNumber && streetNumber) {
      fillAddress.street = street + ' ' + streetNumber;
    }
    if (countryCode) {
      fillAddress.countryCode = countryCode;
    }
  }
};

const getPlaceByAddressString = (address, callback = () => {}) => {
  if (
    typeof useGoogleApiValidation === 'undefined' ||
    !useGoogleApiValidation ||
    typeof google === 'undefined' ||
    !google.maps ||
    !google.maps.places
  ) {
    callback(null);
    return;
  }

  const autocompleteService = new google.maps.places.AutocompleteService();
  autocompleteService.getPlacePredictions(
    { input: address, types: ['geocode'] },
    (predictions, status) => {
      if (
        status === google.maps.places.PlacesServiceStatus.OK &&
        predictions &&
        predictions.length > 0
      ) {
        const placesService = new google.maps.places.PlacesService(document.createElement('div'));
        placesService.getDetails(
          { placeId: predictions[0].place_id },
          (place, detailsStatus) => {
            if (detailsStatus === google.maps.places.PlacesServiceStatus.OK) {
              callback(place);
            } else {
              callback(null);
            }
          }
        );
      } else {
        callback(null);
      }
    }
  );
};

const parseAddressComponents = (address_components) => {
  let country = '';
  let countryCode = '';
  let route = '';
  let streetNumber = '';
  let premise = '';
  let locality = '';
  let sublocality = '';
  let neighborhood = '';
  let postalCode = '';
  let postalTown = '';

  if (address_components) {
    address_components.forEach((component) => {
      if (component.types.indexOf('country') !== -1) {
        country = component.long_name;
        countryCode = component.short_name;
      }
      if (component.types.indexOf('route') !== -1) {
        route = component.long_name;
      }
      if (component.types.indexOf('street_number') !== -1) {
        streetNumber = component.long_name;
      }
      if (component.types.indexOf('premise') !== -1) {
        premise = component.long_name;
      }
      if (component.types.indexOf('locality') !== -1) {
        locality = component.long_name;
      }
      if (component.types.indexOf('sublocality') !== -1) {
        sublocality = component.long_name;
      }
      if (component.types.indexOf('neighborhood') !== -1) {
        neighborhood = component.long_name;
      }
      if (component.types.indexOf('postal_code') !== -1) {
        postalCode = component.long_name;
      }
      if (component.types.indexOf('postal_town') !== -1) {
        postalTown = component.long_name;
      }
    });
  }

  return {
    country,
    countryCode,
    route,
    streetNumber,
    premise,
    locality,
    sublocality,
    neighborhood,
    postalCode,
    postalTown,
    address_components: address_components ? address_components : []
  };
};

const getIdCountryByCountryCode = (country_code) => {
  if (typeof countries !== 'undefined' && typeof country_code !== 'undefined' && country_code) {
    for (const key in countries) {
      if (countries.hasOwnProperty(key)) {
        if (countries[key].iso_code && countries[key].iso_code.toUpperCase() === country_code.toUpperCase()) {
          return countries[key].id_country;
        }
      }
    }
  }
  return null;
};

const fillAddressInputs = (addressData, type) => {
  let addressInputSelector = '#address1';
  if (typeof type !== 'undefined' && type !== '') {
    addressInputSelector += '_' + type;
  }

  let cityInputSelector = '#city';
  if (typeof type !== 'undefined' && type !== '') {
    cityInputSelector += '_' + type;
  }

  let postcodeInputSelector = '#postcode';
  if (typeof type !== 'undefined' && type !== '') {
    postcodeInputSelector += '_' + type;
  }

  $(addressInputSelector).val(addressData.street);
  $(cityInputSelector).val(addressData.city);
  $(postcodeInputSelector).val(addressData.postalCode);

  const id_country = getIdCountryByCountryCode(addressData.countryCode);
  let countryInputSelector = '#id_country';
  if (typeof type !== 'undefined' && type !== '') {
    countryInputSelector += '_' + type;
  }

  const country = $(countryInputSelector);
  if (country.length && !country.prop('disabled') && id_country !== null) {
    country.val(id_country).change();
  }

  const current = country.val();
  if (current != id_country) {
    // Zobraz chybu
    country.addClass('is-invalid').removeClass('is-valid');
    $('#addressess-errors').html('<ol><li>' + txtErrorWrongDeliveryCountry + '</li></ol>').show();
    $('html, body').animate({scrollTop: getTop()}, 1200 );
  } else {
    country.removeClass('is-invalid').addClass('is-valid');
    $('#addressess-errors').html('').hide();
  }
};

const getTop = () => {
  return $("#checkout-left").first().offset().top - 65;
};

// Vrátí prediction (stejně jako autocomplete) pro zadaný address string, bez UI
const getPlacePredictionByAddressString = (address, callback = () => {}) => {
  if (typeof useGoogleApiValidation === 'undefined' || !useGoogleApiValidation || typeof google === 'undefined' || !google.maps || !google.maps.places) {
    callback(null);
    return;
  }
  const service = new google.maps.places.AutocompleteService();
  service.getPlacePredictions({ input: address, types: ['geocode'] }, (predictions, status) => {
    if (status === google.maps.places.PlacesServiceStatus.OK && predictions && predictions.length > 0) {
      // Najdi prediction s nejkratším place_id
      var shortest = predictions[0];
      for (var i = 1; i < predictions.length; i++) {
        if (predictions[i].place_id.length < shortest.place_id.length) {
          shortest = predictions[i];
        }
      }
      callback(shortest);
    } else {
      callback(null);
    }
  });
};

const addGoogleAutocomplete = (type) => {
  if (
    typeof useGoogleApiValidation === 'undefined' ||
    !useGoogleApiValidation ||
    typeof google === 'undefined' ||
    !google.maps ||
    !google.maps.places
  ) {
    return;
  }

  let addressInputSelector = 'address1';
  if (typeof type !== 'undefined' && type !== '') {
    addressInputSelector += '_' + type;
  }

  const addressInput = document.getElementById(addressInputSelector);
  if (addressInput) {
    const autocomplete = new google.maps.places.Autocomplete(addressInput, {
      types: ['geocode'],
    });

    autocomplete.addListener('place_changed', () => {
      const addressString = addressInput.value;
      const autocompletePlace = autocomplete.getPlace();

      validateAndFillAddressAsync(addressString, autocompletePlace, type, (res) => {
        if (res.result === true && res.placeId) {
          updatePlaceAjax(res.placeId, type);
        }
      });
    });
  }
};

const CheckUpdateAddressOperations = {
  switchErrorStat: () => {

    if (errorMsg !== '') {
      // eslint-disable-next-line
      const strError = '<article class="alert alert-danger" role="alert" data-alert="danger"><ul>' + errorMsg + '</ul></article>';
      $('#notifications .container').html(strError);
      errorMsg = '';
    } else {
      $('#notifications .container').empty();
    }
  },
  checkUpdateOpertation: (resp) => {

    hasError = resp.hasOwnProperty('hasError');
    const errors = resp.errors || '';

    // 1.7.2.x returns errors as string, 1.7.3.x returns array

    var error;


    for (error in errors) {
      //IE6 bug fix
      if (error != 'indexOf') {
        errorMsg += '<li>' + resp.errors[error] + '</li>';
      }
    }



    // if (errors instanceof Array) {
    //   console.log('dddd');
    //   errorMsg = errors.join(' ');
    // }
    // if (typeof errors === "object") {
    //   console.log('wwww');
    //   var errors_arr = $.makeArray( errors );
    //   errorMsg = errors_arr.join(' ');
    // }
    // else {
    //   console.log('aaaa');
    //   errorMsg = errors;
    // }

    isUpdateOperation = true;
  },
};